<template>
    <el-col :span="24" :lg="lg">
        <v-autocomplete
            rounded="sm"
            :clearable="clearable"
            @update:modelValue="updateSelectedItem"
            density="comfortable"
            v-model="modelValueRef"
            item-color="#fff"
            :label="label"
            :items="data"
            :display="itemTitle"
            :item-value="itemValue"
            variant="outlined"
            :hide-details="hideDetails"
        >
            <template v-slot:prepend-inner>
                <i :class="'ti ti-' + icon"></i>
            </template>
        </v-autocomplete>
    </el-col>
</template>

<script>
    import { defineComponent, onMounted, ref, watch } from 'vue'
    import { UserIcon } from 'vue-tabler-icons'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'
    export default defineComponent({
        props: {
            modelValue: Number,
            label: {
                type: String,
                default: 'Select',
            },
            endpoint: null,
            text: null,
            lg: {
                type: String,
                default: '12',
            },
            isAllStatus: {
                type: Boolean,
                default: false,
            },
            isResign: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: true,
            },
            hideDetails: {
                type: Boolean,
                default: true,
            },
            icon: {
                type: String,
                default: 'selector',
            },
            display: {
                type: String,
                default: 'text',
            },
            value: {
                type: String,
                default: 'id',
            },
        },
        setup(props, { emit }) {
            const data = ref([])
            const value = ref(null)
            const modelValueRef = ref(props.modelValue)

            const fetchData = async () => {
                try {
                    axios.get(props.endpoint).then(response => {
                        if (response.status == 200) {
                            data.value = response.data
                            let firstKey = Object.keys(data.value[0])[0]
                            value.value = firstKey
                        }
                    })
                } catch (error) {
                    console.log(error)
                }
            }
            const updateSelectedItem = newValue => {
                emit('update:modelValue', newValue)
            }

            onMounted(() => {
                fetchData()
            })

            return {
                data,
                value,
                modelValueRef,
                updateSelectedItem,
            }
        },
        watch: {
            modelValue(newValue) {
                this.modelValueRef = newValue
                //console.log(newValue)
            },
        },
    })
</script>
